import { render, staticRenderFns } from "./release_success.vue?vue&type=template&id=3d0feb4b&scoped=true"
import script from "./release_success.vue?vue&type=script&lang=js"
export * from "./release_success.vue?vue&type=script&lang=js"
import style0 from "./release_success.vue?vue&type=style&index=0&id=3d0feb4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0feb4b",
  null
  
)

export default component.exports